'use client';

import React, { createContext, useContext, useState, useCallback } from 'react';
import { Toast, ToastProps, ToastType } from '@/components/ui/Toast';

interface ToastContextType {
    showToast: (message: string, type?: ToastType, duration?: number) => void;
}

const ToastContext = createContext<ToastContextType | undefined>(undefined);

export const useToast = () => {
    const context = useContext(ToastContext);
    if (!context) {
        throw new Error('useToast must be used within a ToastProvider');
    }
    return context;
};

export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [toast, setToast] = useState<ToastProps | null>(null);

    const showToast = useCallback((message: string, type: ToastType = 'success', duration = 3000) => {
        setToast({
            message,
            type,
            duration,
            onClose: () => setToast(null),
        });
    }, []);

    return (
        <ToastContext.Provider value={{ showToast }}>
            {children}
            {toast && <Toast {...toast} />}
        </ToastContext.Provider>
    );
};
